import React from 'react';

import ShareIcon from '@mui/icons-material/Share';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const ShareActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <ShareIcon />
    </BaseActionButton>
  );
};

export default ShareActionButton;
